import React, { useEffect } from "react";
import "./NetworkingCarousel.css";
import { Link } from "react-router-dom";

const NetworkingCarousel = () => {

  useEffect(() => {
      const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY;
  
        const animatables = document.querySelectorAll('.animatable');
  
        animatables.forEach(animatable => {
          const elementTop = animatable.getBoundingClientRect().top + scrollY;
          const elementBottom = elementTop + animatable.clientHeight;
  
          // Check if element is in the viewport
          if (scrollY + windowHeight > elementTop && scrollY < elementBottom) {
            animatable.classList.add('animated');
            animatable.classList.remove('animatable');
          } else {
            // Reset the animation when the element is out of view
            animatable.classList.remove('animated');
            animatable.classList.add('animatable');
          }
        });
      };
  
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Trigger animation on mount
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);


  return (
    <div
      id="networking-carousel-block"
      className="gd--s--carousel-block"
      style={{
        backgroundImage:
          "url('./images/hp-banner2.jpg')",
      }}
      role="img"
      aria-label="Networking Carousel">
      <div className="gd--s--container">
        <div className="gd--s--row">
          <div
            id="networking-carousel"
            className="gd--s--col-12 gd--s--d-flex gd--s--align-center gd--s--justify-center ">
            <h1 style={{ color: "#fff" }} className="block animatable bounceIn">Chairman’s Vision</h1>
            <div className="gd--s--myslider">
              {/* Slide 1 */}
              <div className="gd--s--item">
                <div className="gd--s--row">
                  <div className="gd--s--col-md-6">
                    <div className="gd--s--networking-left">
                      {/* <h6>Scale Up</h6> */}
                      <h4 className="block animatable bounceIn">
                        Mind When Stretched by a New Idea Never Regains its
                        Original Dimensions!
                      </h4>
                      <p className="block animatable bounceInRight">
                        "Education must prepare students for the unpredictable
                        challenges of the future. At Shiva Ganga Group, we aim to create institutions where students
                        not only excel academically but also grow into
                        empathetic and responsible citizens." – Thota Shiva
                        Kumar, Chairman
                      </p>
                    </div>
                  </div>
                  <div className="gd--s--col-md-6 gd--s--d-flex gd--s--align-end">
                    <div className="gd--s--networking-right">
                      <img
                        src="./images/Chairman.png"
                        alt="Chairman"
                        width="110"
                        height="110" className="block animatable bounceIn"
                      />
                      <div className="gd--s--networking-testimonial">
                        {/* <p>
                          Mind When Stretched by a New Idea Never Regains its
                          Original Dimensions!
                        </p> */}
                        <p className="block animatable bounceInRight">Mr. Thota Shiva Yadav</p>
                        <p className="block animatable bounceInRight">(Chairman) | Shri Shiva Ganga Group</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h2 style={{ color: "#fff" }} className="block animatable bounceInLeft">Institutions</h2>

              {/* Slide 2 */}
              <div className="gd--s--item">
                <div className="gd--s--row">
                  <div className="gd--s--col-md-6">
                    
                  <div className="gd--s--networking-left">
                      <div className="institutions-box block animatable bounceInLeft">
                        <img
                          src="./images/aekaksh-school-logo.PNG"
                          alt=""
                          className="institutions-image"
                        />
                        <h2 className="institutions-heading">
                        Aekaksh School LB Nagar
                        </h2>
                        <Link
                          to="https://www.aekakshschool.com/"
                          className="common-button">
                          Learn More
                        </Link>
                      </div>
                    </div>
                    
                  </div>
                  <div className="gd--s--col-md-6 gd--s--d-flex gd--s--align-end">
                  <div className="gd--s--networking-left">
                      <div className="institutions-box block animatable bounceInRight">
                        <img
                          src="./images/gd-logo.PNG"
                          alt=""
                          className="institutions-image"
                        />
                        <h2 className="institutions-heading">
                          GD Goenka School Hyderabad
                        </h2>
                        <Link
                          to="https://gdgoenkahyd.com/"
                          className="common-button">
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 3 */}
              <div className="gd--s--item">
                <div className="gd--s--row">
                  <div className="gd--s--col-md-6">
                    <div className="gd--s--networking-left">
                      <div className="institutions-box ">
                        <img
                          src="./images/soulsportza-logo.PNG"
                          alt="Soul Sportza LB Nagar"
                          className="institutions-image"
                        />
                        <h2 className="institutions-heading">
                        Soul Sportza LB Nagar
                        </h2>
                        <Link
                          to="https://soulsportza.com/"
                          className="common-button">
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="gd--s--col-md-6 gd--s--d-flex gd--s--align-end">
                  <div className="gd--s--networking-left">
                      <div className="institutions-box ">
                        <img
                          src="./images/aekaksh-school-logo.PNG"
                          alt=""
                          className="institutions-image"
                        />
                        <h2 className="institutions-heading">
                        Aekaksh School Moosrambagh
                        </h2>
                        <Link
                          to="https://aekaksh2.netlify.app"
                          className="common-button">
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 4 */}
              <div className="gd--s--item">
                <div className="gd--s--row">
                  <div className="gd--s--col-md-6">
                    {/* <div className="gd--s--networking-left">
                      <div className="institutions-box">
                        <img
                          src="./images/soulsportza-logo.PNG"
                          alt="Soul Sportza LB Nagar"
                          className="institutions-image"
                        />
                        <h2 className="institutions-heading">
                        Soul Sportza LB Nagar
                        </h2>
                        <Link
                          to="https://soulsportza.com/"
                          className="common-button">
                          Learn More
                        </Link>
                      </div>
                    </div> */}
                  </div>
                  <div className="gd--s--col-md-6 gd--s--d-flex gd--s--align-end">
                  <div className="gd--s--networking-left">
                      <div className="institutions-box">
                        <img
                          src="./images/aekaksh-school-logo.PNG"
                          alt="Aekaksh School Karmanghat"
                          className="institutions-image"
                        />
                        <h2 className="institutions-heading">
                        Aekaksh School Karmanghat
                        </h2>
                        <Link
                          to="https://aekaksh2311.netlify.app"
                          className="common-button">
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Add more slides here */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkingCarousel;
